// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */

import React, { useEffect, useState } from 'react';
import { prependZero } from '../lib/utility';

interface TimerProps {
  startedTime: Date;
  endLabTime?: Date;
  duration: number;
  onTimesUp: () => void;
}

function timeDiff(startTime: Date, endTime: Date) {
  return Math.floor((endTime.getTime() - startTime.getTime()) / 1000)
}

const Timer = (timerProps:TimerProps): JSX.Element => {
  const {
    startedTime,
    endLabTime,
    duration,
    onTimesUp
  } = timerProps;

  const endTime = new Date(startedTime.getTime() + duration * 1000);

  const [timeLeft, setTimeLeft] = useState<number>(timeDiff(new Date(), endTime));
  const [callbackFired, setCallbackFired] = useState(false);

  useEffect(() => {
    if (endLabTime) {
      setTimeLeft(timeDiff(endLabTime, endTime))
    } else {
      const interval = setInterval(() => {
        const now = new Date();

        if (now >= endTime) {
          setTimeLeft(0);
        } else {
          setTimeLeft(timeDiff(now, endTime))
        }
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [endLabTime]);

  useEffect(() => {
    if (timeLeft <= 0 && !callbackFired) {
      onTimesUp();
      setCallbackFired(true);
    }
  }, [timeLeft])

  const second = timeLeft % 60;
  const minute = Math.floor((timeLeft / 60) % 60);
  const hour = Math.floor(timeLeft / 3600);

  return (
    <>{prependZero(hour) + ':' + prependZero(minute) + ':' + prependZero(second)}</>
  );
}

export default Timer;
